import { addDays } from 'date-fns';
import { useQuery } from 'react-query';
import { Pagination } from '../../../../../../types/Common';
import { PartyMinimalObject } from '../../../../../../types/SMT';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { useDistributionId } from '../../../../../app/src/features/authentication/api/get/getDistribution';
import { PartiesOverviewFilterValues } from '../types/Filter';

interface Params {
  filters?: Partial<PartiesOverviewFilterValues>;
  distributionId: string;
  page?: number;
  pagelen?: number;
  query?: string;
  version?: 'v1' | 'v2';
  enabled?: boolean;
}

export interface PartiesResponse {
  pagination: Pagination;
  items: PartyMinimalObject[];
}

export const getParties = async ({
  filters,
  distributionId,
  page,
  query,
  pagelen = 10,
  version = 'v1',
}: Params) => {
  const { data, isError } = await wgApi.get<PartiesResponse>(
    `/${version}/api/distributions/${distributionId}/parties`,
    {
      query: {
        page,
        q: query,
        pagelen,
        order_by: 'created_at',
        created_at_ge:
          filters?.date?.[0] && addDays(filters?.date[0], 1)?.toISOString(),
        created_at_le:
          filters?.date?.[1] && addDays(filters?.date[1], 1)?.toISOString(),
        assignee: filters?.assignedTo,
        status: filters?.status,
        statute: filters?.legalType,
        origin: filters?.origin,
        archived: filters?.displayArchived,
        company_registration_nr: filters?.company_registration_nr,
        company_registration_type: filters?.company_registration_type,
      },
    },
  );
  if (isError) throw new Error();
  return data;
};

type QParams = Omit<Params, 'distributionId'>;

export const getUsePartiesQKey = () => ['portfolio', 'parties'];
export const getUsePartiesWithFiltersQKey = (params?: QParams) => [
  ...getUsePartiesQKey(),
  params,
];

export const useParties = ({ enabled = true, ...params }: QParams) => {
  const distributionId = useDistributionId();

  return useQuery(
    getUsePartiesWithFiltersQKey(params),
    () =>
      getParties({
        ...params,
        distributionId,
      }),
    {
      refetchOnWindowFocus: false,
      // refetchOnMount: false,
      enabled,
    },
  );
};
